export default __webpack_public_path__ + "static/media/Details.18464422.svg";